
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/el/articles/[article]",
      function () {
        return require("private-next-pages/el/articles/[article].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/el/articles/[article]"])
      });
    }
  